import gql from "graphql-tag";

export const CONFIRM_EMAIL = gql`
  mutation DOCTOR_CHANGE_EMAIL($token: String!) {
    registerTokenEmail(token: $token)
  }
`
